export const FIND_PRODUCT_BY_ID_REQUEST = "FIND_PRODUCT_BY_ID_REQUEST";
export const FIND_PRODUCT_BY_ID_SUCCESS = "FIND_PRODUCT_BY_ID_SUCCESS";
export const FIND_PRODUCT_BY_ID_FAILURE = "FIND_PRODUCT_BY_ID_FAILURE";

export const FIND_PRODUCTS_REQUEST = "FIND_PRODUCTS_REQUEST";
export const FIND_PRODUCTS_SUCCESS = "FIND_PRODUCTS_SUCCESS";
export const FIND_PRODUCTS_FAILURE = "FIND_PRODUCTS_FAILURE";

export const SEARCH_PRODUCTS_REQUEST = "SEARCH_PRODUCTS_REQUEST";
export const SEARCH_PRODUCTS_SUCCESS = "SEARCH_PRODUCTS_SUCCESS";
export const SEARCH_PRODUCTS_FAILURE = "SEARCH_PRODUCTS_FAILURE";

export const FIND_PRODUCTS_BY_BRAND_REQUEST = "FIND_PRODUCT_BY_BRAND_REQUEST";
export const FIND_PRODUCTS_BY_BRAND_SUCCESS = "FIND_PRODUCT_BY_BRAND_SUCCESS";
export const FIND_PRODUCTS_BY_BRAND_FAILURE = "FIND_PRODUCT_BY_BRAND_FAILURE";

export const FIND_PRODUCTS_BY_VENDOR_REQUEST = "FIND_PRODUCT_BY_VENDOR_REQUEST";
export const FIND_PRODUCTS_BY_VENDOR_SUCCESS = "FIND_PRODUCT_BY_VENDOR_SUCCESS";
export const FIND_PRODUCTS_BY_VENDOR_FAILURE = "FIND_PRODUCT_BY_VENDOR_FAILURE";

export const FIND_PRODUCTS_BY_OFFER_REQUEST = "FIND_PRODUCT_BY_OFFER_REQUEST";
export const FIND_PRODUCTS_BY_OFFER_SUCCESS = "FIND_PRODUCT_BY_OFFER_SUCCESS";
export const FIND_PRODUCTS_BY_OFFER_FAILURE = "FIND_PRODUCT_BY_OFFER_FAILURE";

export const FIND_PRODUCTS_BY_BRAND_AND_OFFERS_REQUEST =
  "FIND_PRODUCT_BY_BRAND_AND_OFFERS_REQUEST";
export const FIND_PRODUCTS_BY_BRAND_AND_OFFERS_SUCCESS =
  "FIND_PRODUCT_BY_BRAND_AND_OFFERS_SUCCESS";
export const FIND_PRODUCTS_BY_BRAND_AND_OFFERS_FAILURE =
  "FIND_PRODUCT_BY_BRAND_AND_OFFERS_FAILURE";

export const GET_ALL_PRODUCTS_REQUEST = "GET_ALL_PRODUCTS_REQUEST";
export const GET_ALL_PRODUCTS_SUCCESS = "GET_ALL_PRODUCTS_SUCCESS";
export const GET_ALL_PRODUCTS_FAILURE = "GET_ALL_PRODUCTS_FAILURE";

export const GET_ALL_PRODUCTS_BY_FILTER_REQUEST = "GET_ALL_PRODUCTS_BY_FILTER_REQUEST";
export const GET_ALL_PRODUCTS_BY_FILTER_SUCCESS = "GET_ALL_PRODUCTS_BY_FILTER_SUCCESS";
export const GET_ALL_PRODUCTS_BY_FILTER_FAILURE = "GET_ALL_PRODUCTS_BY_FILTER_FAILURE";

export const GET_ALL_PRODUCTS_BY_SUBCATEGORY_FILTER_REQUEST =
  "GET_ALL_PRODUCTS_BY_SUBCATEGORY_FILTER_REQUEST";
export const GET_ALL_PRODUCTS_BY_SUBCATEGORY_FILTER_SUCCESS =
  "GET_ALL_PRODUCTS_BY_SUBCATEGORY_FILTER_SUCCESS";
export const GET_ALL_PRODUCTS_BY_SUBCATEGORY_FILTER_FAILURE =
  "GET_ALL_PRODUCTS_BY_SUBCATEGORY_FILTER_FAILURE";

export const GET_ALL_PRODUCTS_BY_BRAND_REQUEST =
  "GET_ALL_PRODUCTS_BY_BRAND_REQUEST";
export const GET_ALL_PRODUCTS_BY_BRAND_SUCCESS =
  "GET_ALL_PRODUCTS_BY_BRAND_SUCCESS";
export const GET_ALL_PRODUCTS_BY_BRAND_FAILURE =
  "GET_ALL_PRODUCTS_BY_BRAND_FAILURE";

export const GET_ALL_PRODUCTS_BY_OFFERS_REQUEST =
  "GET_ALL_PRODUCTS_BY_OFFERS_REQUEST";
export const GET_ALL_PRODUCTS_BY_OFFERS_SUCCESS =
  "GET_ALL_PRODUCTS_BY_OFFERS_SUCCESS";
export const GET_ALL_PRODUCTS_BY_OFFERS_FAILURE =
  "GET_ALL_PRODUCTS_BY_OFFERS_FAILURE";

export const GET_ALL_PRODUCTS_BY_BRAND_AND_OFFERS_REQUEST =
  "GET_ALL_PRODUCTS_BY_BRAND_AND_OFFERS_REQUEST";
export const GET_ALL_PRODUCTS_BY_BRAND_AND_OFFERS_SUCCESS =
  "GET_ALL_PRODUCTS_BY_BRAND_AND_OFFERS_SUCCESS";
export const GET_ALL_PRODUCTS_BY_BRAND_AND_OFFERS_FAILURE =
  "GET_ALL_PRODUCTS_BY_BRAND_AND_OFFERS_FAILURE";

export const GET_ALL_PRODUCTS_BY_BRAND_AND_VENDOR_AND_OFFERS_REQUEST =
  "GET_ALL_PRODUCTS_BY_BRAND_AND_VENDOR_AND_OFFERS_REQUEST";
export const GET_ALL_PRODUCTS_BY_BRAND_AND_VENDOR_AND_OFFERS_SUCCESS =
  "GET_ALL_PRODUCTS_BY_BRAND_AND_VENDOR_AND_OFFERS_SUCCESS";
export const GET_ALL_PRODUCTS_BY_BRAND_AND_VENDOR_AND_OFFERS_FAILURE =
  "GET_ALL_PRODUCTS_BY_BRAND_AND_VENDOR_AND_OFFERS_FAILURE";

export const GET_ALL_PRODUCTS_BY_BRAND_AND_VENDOR_REQUEST =
  "GET_ALL_PRODUCTS_BY_BRAND_AND_VENDOR_REQUEST";
export const GET_ALL_PRODUCTS_BY_BRAND_AND_VENDOR_SUCCESS =
  "GET_ALL_PRODUCTS_BY_BRAND_AND_VENDOR_SUCCESS";
export const GET_ALL_PRODUCTS_BY_BRAND_AND_VENDOR_FAILURE =
  "GET_ALL_PRODUCTS_BY_BRAND_AND_VENDOR_FAILURE";

export const GET_ALL_PRODUCTS_BY_VENDOR_AND_OFFERS_REQUEST =
  "GET_ALL_PRODUCTS_BY_VENDOR_AND_OFFERS_REQUEST";
export const GET_ALL_PRODUCTS_BY_VENDOR_AND_OFFERS_SUCCESS =
  "GET_ALL_PRODUCTS_BY_VENDOR_AND_OFFERS_SUCCESS";
export const GET_ALL_PRODUCTS_BY_VENDOR_AND_OFFERS_FAILURE =
  "GET_ALL_PRODUCTS_BY_VENDOR_AND_OFFERS_FAILURE";

export const GET_ALL_PRODUCTS_BY_CATEGORY_REQUEST = "CREATE_PRODUCT_REQUEST";
export const GET_ALL_PRODUCTS_BY_CATEGORY_SUCCESS = "CREATE_PRODUCT_SUCCESS";
export const GET_ALL_PRODUCTS_BY_CATEGORY_FAILURE = "CREATE_PRODUCT_FAILURE";

export const GET_ALL_PRODUCTS_BY_GRAND_PARENT_CATEGORY_REQUEST =
  "CREATE_PRODUCT_REQUEST";
export const GET_ALL_PRODUCTS_BY_GRAND_PARENT_CATEGORY_SUCCESS =
  "CREATE_PRODUCT_SUCCESS";
export const GET_ALL_PRODUCTS_BY_GRAND_PARENT_CATEGORY_FAILURE =
  "CREATE_PRODUCT_FAILURE";

export const GET_ALL_PRODUCTS_BY_SEARCH_AND_FILTER_REQUEST = "GET_ALL_PRODUCTS_BY_SEARCH_AND_FILTER_REQUEST";
export const GET_ALL_PRODUCTS_BY_SEARCH_AND_FILTER_SUCCESS = "GET_ALL_PRODUCTS_BY_SEARCH_AND_FILTER_SUCCESS";
export const GET_ALL_PRODUCTS_BY_SEARCH_AND_FILTER_FAILURE = "GET_ALL_PRODUCTS_BY_SEARCH_AND_FILTER_FAILURE";
